export default "__VITE_ASSET__Do6BBnno__"